import styled from 'styled-components';
import { InputSearch } from 'ui/inputs';
import { SecondaryButton } from 'ui/button';
import { WarningBanner } from 'ui/banner';
import { CheckboxGridCell, LastModifiedCell } from 'ui/indexPages/tables/cells';
import { GridRow, HeaderGridRow } from 'ui/indexPages/tables/grid';
import { PaginationFooter } from 'ui/paginationFooter';
import { body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing.plusHalf};
`;

export const BtnAndSearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.base};
  [data-test='list-input-search-wrapper'] {
    height: ${pxToRem(40)};
  }
`;

export const DetachedSearchWrapper = styled.div`
  width: ${pxToRem(280)};
  position: absolute;
  top: ${spacing.half};
  right: 0;
`;

export const SelectedListsCountBtn = styled(SecondaryButton)`
  pointer-events: none;
  &&& {
    background: ${colors.purple10};
    border-color: ${colors.purple20};
    color: ${colors.purple90};
    path {
      stroke: ${colors.purple90};
    }
  }
`;

export const WideInputSearch = styled(InputSearch)`
  width: ${pxToRem(280)};
`;

export const TABLE_GRID = `
    ${pxToRem(65)} // send checkbox
    ${pxToRem(67)} // suppress checkbox
    minmax(${pxToRem(160)}, 1fr) // name
    ${pxToRem(101)} // id
    ${pxToRem(109)} // type
    ${pxToRem(90)} // contacts
    ${pxToRem(200)} // last modified
`;

export const TABLE_GRID_ELIGIBILITY = `
    ${pxToRem(84)} // eligible checkbox
    minmax(${pxToRem(160)}, 1fr) // name
    ${pxToRem(101)} // id
    ${pxToRem(109)} // type
    ${pxToRem(90)} // contacts
    ${pxToRem(200)} // last modified
`;

export const TableWrapper = styled.div<{ $isExpanded?: boolean }>`
  flex: 2;
  box-sizing: border-box;
  overflow: hidden;
  height: ${({ $isExpanded }) => ($isExpanded ? '80%' : 'auto')};
`;

export const TableHeader = styled(HeaderGridRow)`
  border-top: none;
  padding-left: 0;
  padding-right: 0;
`;

export const TableRow = styled(GridRow)`
  align-items: center;
  padding-left: 0;
  padding-right: 0;
`;

export const Cell = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  ${body2};
  padding: 0 ${spacing.half};
`;

export const ContactsCell = styled(Cell)`
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: ${pxToRem(26)};
`;

export const CheckboxCell = styled(CheckboxGridCell)`
  display: flex;
  justify-content: center;
  padding: 0 ${spacing.half};
`;

export const RadioCell = styled(Cell)`
  align-items: center;
`;

export const NameCell = styled(Cell)`
  > span {
    ${body2};
    color: ${colors.textSecondary};
    margin-top: ${spacing.quarter};
  }
`;

export const ListLastModifiedCell = styled(LastModifiedCell)`
  > div > div {
    padding-left: ${spacing.half};
  }
`;

export const MultiLineLoadingCell = styled(Cell)`
  gap: ${spacing.half};
`;

export const Description = styled.span`
  overflow-wrap: anywhere;
`;

export const AudienceSelectionPaginationFooter = styled(PaginationFooter)`
  border-top: none;
  padding: ${spacing.base} ${spacing.plusHalf};
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const EmptyStateSubtitle = styled.span`
  color: ${colors.textSecondary};
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.double};
`;
